//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
export default {
    data() {
            return {
                isClick: true,
                isShowMore: false,
                isShowMask: false,
                music_src: '',//音乐列表下的src(音频播放的url地址;)
                songName: '',
                singerName: '',
                page: 0,
                src: '' //下载按钮的url地址;动态变化;
            }
        },
        methods: {
            playStatus() {
                var audio = document.getElementById('audio');
                //播放按钮与audio的同步绑定;
                this.isClick = audio.paused //绑定显示状态与播放状态一致;
                    //判断状态 : 暂停与播放
                if (audio.paused) {
                    audio.play(); //audio.play();// 这个就是播放  

                } else {
                    audio.pause(); // 这个就是暂停
                }
            },
            showMore() {
                this.isShowMore = !this.isShowMore;
                this.isShowMask = !this.isShowMask;
            },
            hide() {
                this.isShowMore = false;
                this.isShowMask = false;
            },
            icondiyPlay(index, hash) { //切换歌曲
                this.page = index;
                //切换歌单下不同的歌曲=>请求MP3;
                axios.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/app/i/getSongInfo.php?cmd=playInfo&hash=' + hash)
                    .then((response) => {
                        this.music_src = response.data.url;
                        //歌手信息与歌曲信息更新
                        this.singerName = response.data.singerName
                        this.songName = response.data.songName
                        //状态更改 (播放按钮, 遮罩层音乐,列表隐藏)
                        this.isClick = true
                        this.isShowMore = false; 
                        this.isShowMask = false;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            download() { //点击下载按钮 下载相应的音乐;
                var audio = document.getElementById('audio');
                var down = document.getElementById('down');
                var src = audio.src
            },
            record_msg(){
                window.location.href = "#/song"
            }

        },
        filters: {
            shortTitle(input) {
                if (input.length > 15) {
                    return input.slice(0, 15) + '...';
                } else {
                    return input
                }
            }
        },
        computed: {
            imgUrl() {
                return this.$store.getters.getImgurl  //传递过来的头像url;
            },
            showPlay() {
                return this.$store.getters.showPlay
            },
            songsPlay() {
                //-----音乐信息渲染-----
                //1.当为0的时候不执行;
                if (this.$store.getters.songsPlay.length === 0) {
                    return
                }
                // 切换不同的歌单=>请求MP3;
                var hash = this.$store.getters.songsPlay[0].hash
                axios.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/app/i/getSongInfo.php?cmd=playInfo&hash=' + hash)
                    .then((response) => {
                        this.music_src = response.data.url;
                        //信息更改
                        this.singerName = response.data.singerName
                        this.songName = response.data.songName
                            //状态更改
                        var audio = document.getElementById('audio');
                        this.page = 0 ;
                        this.isClick = true

                        //传递信息给唱片组件---重要--
                       var record = this.$store.getters.songsPlay;
                       this.$store.dispatch('setRecord',record);
                       this.$store.dispatch('setrecordCover',record);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                return this.$store.getters.songsPlay
            }
        },
        mounted() {
            //-----播放结束的条件判断;  自动播放下一首歌曲;-(_故障,无法实时更新music_src路径,导致单曲循环;)-----
            var index = 2;
            var audio = document.getElementById('audio');
            audio.onended = function(e) {
                    var hash = self.$store.getters.songsPlay[index].hash;
                    axios.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/app/i/getSongInfo.php?cmd=playInfo&hash=' + hash)
                        .then((response) => {
                            this.music_src = response.data.url;
                            console.log(this.music_src)
                                //信息更改
                            this.singerName = response.data.singerName
                            this.songName = response.data.songName
                                //状态更改
                            var audio = document.getElementById('audio');
                            audio.play()
                            this.isClick = true
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            //---进度条;
                //同步进度条事件
            var progress = document.getElementById('progress');
            var bar = document.getElementById('bar');

            audio.addEventListener('timeupdate',function() {
                var scales = audio.currentTime / audio.duration
                bar.style.width = progress.offsetWidth*scales +"px"; //进度条实时算法;
            },false)
            
        }
}



// WEBPACK FOOTER //
// ./src/components/xplay.vue